import Styles from './HiringResume.module.scss';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';

// module imports
import EditIcon from '@mui/icons-material/Edit';
import ArticleIcon from '@mui/icons-material/Article';
import DownloadIcon from '@mui/icons-material/Download';
// import { usePDF } from 'react-to-pdf';
import ReactToPrint, { PrintContextConsumer }  from 'react-to-print';

// component imports
import { ResumeGenerator } from 'components/global/ResumeGenerator/ResumeGenerator';
import { Message, useAPI } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

export function HiringResume(props) {
    const navigate = useNavigate();
    const { data, loading } = useAPI('/api/hiring/profile');
    const [profileData, setProfileData] = useState({});
    const resumeRef1 = useRef(null);
    // eslint-disable-next-line no-unused-vars
    let reportTemplateRef = useRef();

    

    useEffect(() => {
        if (data) {
            if (data.createProfile) {
                navigate('/hiring/profile')
                return;
            }
            setProfileData(data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])


    return (
        <>
           
            <PrintContextConsumer>
            {({ handlePrint }) => (
              <button onClick={handlePrint}>Print this out!</button>
            )}
          </PrintContextConsumer>
            {/* </ReactToPrint> */}
            <Message
                closable
                title="Resume Preview"
                text="This is an auto-generated resume preview which is shown to Hiring Managers! Edit your profile to update your resume!"
                type="info"
            />

            <div id='ancestorContainer' className={Styles.ancestorContainer}>
                <div id='titleHeader' className={Styles.titleHeader}>
                    <span>
                        <ArticleIcon fontSize='small' sx={{ mr: 1 }} /> Preview Resume
                    </span>
                    <ReactToPrint
                        copyStyles={true}
                        // trigger={() => <button>Print this out!</button>}
                        content={() => document.getElementById('resumeContainer')}
                    >
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <button
                                    id='confirmDownload'
                                    className={Styles.confirmDownload}
                                    disabled={!Object.keys(profileData).length}
                                    onClick={handlePrint}
                                >
                                    <DownloadIcon fontSize='small' /> Download
                                </button>
                            )}
                        </PrintContextConsumer>

                    </ReactToPrint>
                </div>
                {loading ? (
                    <div>
                        <LoadingBackdrop isOpen={true} />
                    </div>
                ) : (
                    <>
                        {
                            Object.keys(profileData).length &&
                            <div id='resumeDisplay'  className={Styles.resumeDisplay} ref={(el) => (reportTemplateRef = el)} >
                                <ResumeGenerator
                                    resumeData={profileData}
                                    resumeRef1={resumeRef1}
                                />
                            </div>
                        }
                    </>
                )}
                <div id='resumeFooter' className={Styles.resumeFooter}>
                    <button id='backButton' className={Styles.backButton}
                        onClick={() => { navigate('/hiring/profile') }}>
                        <EditIcon fontSize='small' /> Edit
                    </button>
                    <button id='confirmButton' className={Styles.confirmButton}
                        onClick={() => { navigate('/hiring/jobs') }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </>
    );
}